import { network } from 'services/network';

import { QueryParams } from 'api/mutations/CreateRiskRegister.mutation';

export const createRiskRegister = (params: QueryParams) => {
    return network.post('api/bo/createRiskRegister', params).then((response) => {
        return response.data;
    });
};
